import type { AvailableProject } from './types';

/**
 * REQ-45 / K-3 — aktif projeyi çöz (çoklu-site switcher).
 *
 * Öncelik sırası:
 *   1. Persist edilen `activeProjectId` hâlâ erişilebilir projeler arasındaysa korunur.
 *   2. Değilse BE'nin bildirdiği `defaultProjectId` (erişilebilir listedeyse).
 *   3. O da yoksa listedeki `isDefault` işaretli proje.
 *   4. Son çare: listenin ilk projesi.
 *   5. Hiç proje yoksa `null` (BE default project'e düşer).
 *
 * Böylece kullanıcı erişimini kaybettiği bir projeye "takılı" kalmaz; her giriş
 * ve her yeniden yükleme (rehydrate) seçimi geçerli bir projeye normalize eder.
 */
export function resolveActiveProjectId(
  persistedActiveId: string | null | undefined,
  availableProjects: readonly AvailableProject[],
  defaultProjectId: string | null | undefined,
): string | null {
  const ids = new Set(availableProjects.map((p) => p.id));

  if (persistedActiveId && ids.has(persistedActiveId)) return persistedActiveId;
  if (defaultProjectId && ids.has(defaultProjectId)) return defaultProjectId;

  const flagged = availableProjects.find((p) => p.isDefault);
  if (flagged) return flagged.id;

  return availableProjects[0]?.id ?? null;
}
